var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.$props.show),expression:"$props.show"}],staticClass:"loader"},[_c('div',{staticClass:"content"},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"label":"Loading...","variant":"light"}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"message"},[_vm._v("Please wait ...")])])
}]

export { render, staticRenderFns }